import i18n from "../../../i18n";
import React from "react";
import { Text, Badge, Table } from "@mantine/core";
import _ from "lodash";

const ByIncentiveRowContent = ({ item, formatter, cellRender }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "SETTLED":
        return "green";
      case "HOLD":
        return "yellow";
      case "PENDING":
      default:
        return "gray";
    }
  };

  const hasCommRate = item.bids?.some((b) => b.commissionRow?.commissionRate);
  const rateLabel = hasCommRate ? "Comm. Rate" : "Percentage";

  return (
    <Table fontSize="sm" striped highlightOnHover>
      <thead>
        <tr>
          <th></th>
          <th>{i18n.t("Bid Code")}</th>
          <th>{i18n.t("Level")}</th>
          <th>{i18n.t("Wallet / User")}</th>
          <th>{rateLabel}</th>
          <th>{i18n.t("Amount")}</th>
          <th>{i18n.t("Status")}</th>
        </tr>
      </thead>
      <tbody>
        {item.bids.map((bid, index) => (
          <tr key={bid._id || index}>
            <td>{index + 1}</td>
            <td>
              <Text size="xs">{bid.code}</Text>
            </td>
            <td>
              <Text size="xs">
                T{bid.tree || 0} / L{bid.level || 0}
              </Text>
            </td>
            <td>
              <Text size="xs">
                {bid.wallet?.name ||
                  bid.wallet?.userGroup?.name ||
                  bid.commissionRow?.userGroup?.name ||
                  bid.commissionRow?.user?.name ||
                  "-"}
              </Text>
            </td>
            <td>
              <Text size="xs">
                {bid.commissionRow?.commissionRate
                  ? `${_.round(bid.commissionRow.commissionRate, 2)}%`
                  : bid.commissionRow?.percentage
                    ? `${_.round(bid.commissionRow.percentage, 2)}%`
                    : "-"}
              </Text>
            </td>
            <td>
              <Text
                size="xs"
                weight={500}
                color={bid.commissionAmount >= 0 ? "green" : "red"}
              >
                {formatter.currency(bid.commissionAmount)}
              </Text>
            </td>
            <td>
              <Badge size="xs" color={getStatusColor(bid.status)}>
                {bid.status}
              </Badge>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ByIncentiveRowContent;
